import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { toDto as toReservationGuestDto } from '../../../models/adapters/ReservationGuestAdapter';
import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import { reservationUpdated, reservationUpdateFailed } from '../../actions/reservation/updateReservation';
import { updateReservationGuest, UpdateReservationGuestPayload } from '../../actions/reservation/updateReservationGuest';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* updateReservationGuestSaga({ payload }: Action<UpdateReservationGuestPayload>) {
  const { reservationGuest } = payload;
  const { reservationUuid } = reservationGuest;
  const reservationGuestDto = toReservationGuestDto(reservationGuest);
  const token = yield getAuthenticationToken();
  const socketPayload = { reservationGuestDto };
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateReservationGuest, token, socketPayload);
  const { error } = response;
  const timestamp = moment();
  if (!error) {
    const getReservationPayload = { reservationUuid: reservationGuest.reservationUuid };
    const getReservationResponse = yield getProtectedResponse(ProtectedServerPlaceEvent.getReservation, token, getReservationPayload);
    const { reservation: reservationDto } = getReservationResponse;
    const reservation = reservationFromDto(reservationDto) as SeatedReservation;
    yield put(reservationUpdated({ reservation, reservationUuid, timestamp, createdMergedTable: null }));
  } else {
    yield put(reservationUpdateFailed({ reservationUuid, timestamp }));
  }
}

export default function* watchUpdateReservationGuestSaga() {
  yield takeEvery(updateReservationGuest, updateReservationGuestSaga);
}
